const _ = require('./enum');

const results = {
  [_.SUCCESS]: { id: _.SUCCESS, label: 'Success' },
  [_.FAILURE]: { id: _.FAILURE, label: 'Failure' },
  [_.PENDING]: { id: _.PENDING, label: 'Pending' },
  [_.ACCEPTED]: { id: _.ACCEPTED, label: 'Accepted' },
  [_.ATTEMPTED]: { id: _.ATTEMPTED, label: 'Attempted' },
  [_.UNAVAILABLE]: { id: _.UNAVAILABLE, label: 'Unavailable' },
  [_.NOT_AVAILABLE]: { id: _.NOT_AVAILABLE, label: 'Not available' },
  [_.DECLINED]: { id: _.DECLINED, label: 'Declined' },
  [_.MANUAL_REVIEW]: { id: _.MANUAL_REVIEW, label: 'Manual review' },
  [_.EXPIRED]: { id: _.EXPIRED, label: 'Expired' },
};

module.exports = results;
